import React, { useCallback, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { Breadcrumb } from "../../../molecules/Breadcrumb";
import { titles } from "../../../constants/titles";
import {
  BULK_UPSERT_TEACHER_SUBJECTS_SUCCESS_MESSAGE,
  bulkUpsertTeacherSubjects,
  clearErrorMessage,
  Context,
  fetchClasses,
  fetchSubClasses,
  fetchSubjects,
  fetchTeachers,
  fetchTeacherSubjectsBySchool,
  subjectsPath,
  clearSuccessMessage,
} from "../../../managerStore";
import { BulkTeacherSubjectForm } from "../../../templates/manager/BulkTeacherSubjectForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";
import { TeacherSubjectForBulkRegister } from "../../../state";

export const BulkRegisterTeacherSubjects = () => {
  const { state, dispatch } = useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const { currentYear } = useCurrentYear();
  const history = useHistory();

  const bulkUpsertTeacherSubjectsFunc = useCallback(
    (teacherSubjects: TeacherSubjectForBulkRegister[]) => {
      dispatch(peep(bulkUpsertTeacherSubjects(teacherSubjects)));
    },
    [dispatch, peep],
  );

  useEffect(() => {
    if (
      state.success_message === BULK_UPSERT_TEACHER_SUBJECTS_SUCCESS_MESSAGE
    ) {
      dispatch(clearSuccessMessage());
      history.push(subjectsPath);
    }
  }, [history, dispatch, state.success_message]);

  useEffect(() => {
    dispatch(fetchTeachers());
    dispatch(fetchSubjects());
    dispatch(fetchClasses(currentYear));
    dispatch(fetchSubClasses());
    dispatch(fetchTeacherSubjectsBySchool());
    return () => dispatch(clearErrorMessage());
  }, [dispatch, currentYear]);

  return (
    <div>
      <Breadcrumb
        links={[{ title: titles.subjects, to: subjectsPath }]}
        currentTitle={titles.bulkRegisterTeacherSubjects}
      />
      <BulkTeacherSubjectForm
        title={titles.bulkRegisterTeacherSubjects}
        teachers={state.teachers}
        subjects={state.subjects}
        classes={state.classes}
        subClasses={state.sub_classes}
        teacherSubjects={state.teacher_subjects_by_school}
        error={state.error}
        calling={calling}
        save={bulkUpsertTeacherSubjectsFunc}
      />
    </div>
  );
};

export default BulkRegisterTeacherSubjects;
